// JS file for ColumnistList
